export default __webpack_public_path__ + "static/media/Scholar's Boots of the Forbidden Art.8a07fdaf.jpg";